import { ThreadInterface } from '../interfaces/messages.interface';

export const parseThreadMessagesHelper = (thread: ThreadInterface): ThreadInterface => {
  thread.messages.reverse().forEach(message => {
    message.user = thread.participants_info.find(participant => participant.id === message.user_id);
  });
  return thread;
};
